import React, { useEffect } from "react";
import { useDoubtActions } from "../../../hooks/useDoubts";
import "./FilterBlog.css";
import "./DoubtReport.css";

const CloseIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M3.33337 3.33334L12.6667 12.6667"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M12.6667 3.33334L3.33337 12.6667"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const AddDoubtModal = ({ open, onClose, onOpen, doubtId, language = "EN", isAdded = false }) => {
  const actions = useDoubtActions(doubtId, language);

  useEffect(() => {
    if (open) {
      onOpen?.();
    }
  }, [open, onOpen]);

  if (!open) return null;

  const handleConfirm = async () => {
    if (doubtId) {
      await actions.toggleMyDoubt.mutateAsync();
      onClose();
    }
  };

  const isPending = actions.toggleMyDoubt.isPending;

  return (
    <div className="filter-blog-overlay" onClick={onClose}>
      <div
        className="filter-blog-modal doubtReport-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="close-btn2 text-end unlock-close-btn">
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            aria-label="Close"
          />
        </div>

        {/* Icon */}
        <div className="premium-icon daily-icon iconnn doubt-icon ms-auto me-auto d-flex">
          <i className="bi bi-bookmark-plus-fill"></i>
        </div>

        {/* Title */}
        <h5 className="fw-bold blackText mb-2 ms-auto me-auto text-center">
          {isAdded ? "Remove Doubt" : "Add a Doubt"}
        </h5>

        <p className="add-doubt-modal__message text-center mb-4">
          {isAdded 
            ? "Do you want to remove this doubt from your list?" 
            : "Do you want to add this doubt to your list?"}
        </p>

        <div className="filter-blog-modal__footer doubtReport-footer">
          <button
            type="button"
            className="filter-blog-modal__action filter-close"
            onClick={onClose}
          >
            <span>Cancel</span>
          </button>

          <button
            type="button"
            className="filter-blog-modal__action filter-blog-modal__action--apply"
            onClick={handleConfirm}
            disabled={isPending}
          >
            <span>{isPending ? "Updating..." : (isAdded ? "Remove" : "Add a Doubt")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDoubtModal;
